var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#3C2190",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#F6F5F8",
    strokeOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 7.49994C11.7009 7.49994 7 12.2008 7 18C7 19.9057 7.50925 21.696 8.39756 23.2374C8.57921 23.5524 8.60966 23.9346 8.45741 24.2633L7.5607 26.1921C7.4345 26.4322 7.37242 26.7008 7.38049 26.9718C7.38855 27.2429 7.46648 27.5074 7.60674 27.7395C7.74699 27.9716 7.94481 28.1636 8.18103 28.2969C8.41726 28.4301 8.68389 28.5001 8.95511 28.5H17.5C23.2992 28.5 28.0001 23.7992 28.0001 18C28.0001 12.2008 23.2992 7.49994 17.5 7.49994ZM14.35 14.85C14.0715 14.85 13.8045 14.9606 13.6076 15.1575C13.4106 15.3544 13.3 15.6215 13.3 15.9C13.3 16.1784 13.4106 16.4455 13.6076 16.6424C13.8045 16.8393 14.0715 16.95 14.35 16.95H16.45C16.7285 16.95 16.9956 16.8393 17.1925 16.6424C17.3894 16.4455 17.5 16.1784 17.5 15.9C17.5 15.6215 17.3894 15.3544 17.1925 15.1575C16.9956 14.9606 16.7285 14.85 16.45 14.85H14.35ZM14.35 19.05C14.0715 19.05 13.8045 19.1606 13.6076 19.3575C13.4106 19.5544 13.3 19.8215 13.3 20.1C13.3 20.3785 13.4106 20.6455 13.6076 20.8425C13.8045 21.0394 14.0715 21.15 14.35 21.15H20.6501C20.9285 21.15 21.1956 21.0394 21.3925 20.8425C21.5894 20.6455 21.7001 20.3785 21.7001 20.1C21.7001 19.8215 21.5894 19.5544 21.3925 19.3575C21.1956 19.1606 20.9285 19.05 20.6501 19.05H14.35Z",
    fill: "#F6F5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.fa66ef3079c713299cfdf014d5e07cd8.svg";
export { ForwardRef as ReactComponent };